
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';

interface AssessmentStatusToggleProps {
  isActive: boolean;
  onStatusChange?: (value: boolean) => void;
  disabled?: boolean;
}

export function AssessmentStatusToggle({
  isActive,
  onStatusChange,
  disabled = false
}: AssessmentStatusToggleProps) {
  return (
    <div className="flex items-center justify-between space-x-2 border p-4 rounded-md">
      <div className="space-y-1">
        <Label htmlFor="assessment-status" className="flex flex-col space-y-1">
          <div className="flex items-center gap-2">
            <span>Assessment Status</span>
            <Badge variant="outline" className={`rounded-full px-3 border-none ${isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'}`}>
              {isActive ? 'Active' : 'Archived'}
            </Badge>
          </div>
          <span className="font-normal text-sm text-muted-foreground">
            {isActive ? 'Active and accepting responses' : 'Temporarily disabled'}
          </span>
        </Label>
      </div>
      <Switch
        id="assessment-status"
        checked={isActive}
        onCheckedChange={onStatusChange}
        disabled={disabled}
        aria-label="Toggle assessment status"
      />
    </div>
  );
}
